import { Sortable, OnSpill } from "sortablejs/modular/sortable.core.esm.js";

Sortable.mount(OnSpill);

export { Sortable };

/*
import { ready } from "./ready";

const checkEmptyDays = (parent) => {
	const calendarDays = [...parent.querySelectorAll('.v3-calendar__day--active')];
	calendarDays.forEach(day => {
		const isDayEmpty = day.querySelector('.v3-calendar__item') === null;
		day.classList.toggle('v3-calendar__day--empty', isDayEmpty);
	});
};

const eventsList = {
	// desktop: ['mousedown', 'mousemove', 'mouseup'],
	desktop: ["pointerdown", "pointermove", "pointerup"],
	// mobile: ['touchstart', 'touchmove', 'touchend']
	mobile: ["pointerdown", "pointermove", "pointerup"],
};

const dragDrop = () => {

	const isTouch = false;

	const withScrollY = document.documentElement.clientHeight < document.body.scrollHeight;
	const withScrollX = document.documentElement.clientWidth < document.body.scrollWidth;
	const docBottom = document.body.getBoundingClientRect().height;
	const docRight = document.body.scrollWidth;

	let isDragging = false;
	let isClick, timer, isCalendar, parent;
	let dragElement, shiftX, shiftY, clone, droppableBelow, eventDown, eventMove, eventEnd, parentalRestrictions;
	if (isTouch) {
		[eventDown, eventMove, eventEnd] = eventsList.mobile;
	} else {
		[eventDown, eventMove, eventEnd] = eventsList.desktop;
	}
	const moveAt = (clientX, clientY) => {
		clone.style.left = clientX - shiftX + 'px';
		clone.style.top = clientY - shiftY + 'px';
	};
	const onMouseMove = (event) => {
		if (isTouch) {
			if (timer) clearTimeout(timer);
		}
		const isKanban = dragElement.matches(".v3-kanbanview-item");
		isClick = false;
		const cloneWidth = clone.getBoundingClientRect().width;
		const cloneTop = clone.getBoundingClientRect().top;
		const cloneBottom = clone.getBoundingClientRect().bottom;
		const cloneMiddelY = clone.getBoundingClientRect().height / 2 + cloneTop;
		const cloneLeft = clone.getBoundingClientRect().left;
		const cloneRight = clone.getBoundingClientRect().right;
		const clientX = isTouch ? event.touches[0].clientX : event.clientX;
		const clientY = isTouch ? event.touches[0].clientY : event.clientY;
		moveAt(clientX, clientY);

		clone.style.visibility = 'hidden';
		const elemBelow = document.elementFromPoint(clientX, clientY);
		clone.style.visibility = '';

		if (withScrollY) {
			if (cloneBottom > document.documentElement.clientHeight) {
				let scrollY = Math.min(docBottom - cloneBottom, 10);
				if (scrollY < 0) scrollY = 0;
				window.scrollBy(0, scrollY);
			}
			if (cloneTop < 0) {
				let scrollY = Math.min(-cloneTop, 10);
				if (scrollY < 0) scrollY = 0;
				window.scrollBy(0, -scrollY);
			}
		}
		if (withScrollX) {
			if (cloneRight > document.documentElement.clientWidth) {
				let scrollX = Math.min(docRight - cloneRight, 10);
				if (scrollX < 0) scrollX = 0;
				window.scrollBy(scrollX, 0);
			}
			if (cloneLeft < 0) {
				let scrollX = Math.min(-cloneLeft, 10);
				if (scrollX < 0) scrollX = 0;
				window.scrollBy(-scrollX, 0,);
			}
		}

		if (!elemBelow) return;

		droppableBelow = elemBelow.closest(".js-droppable");
		if (isKanban) {
			parent = dragElement.closest(".v3-kanbanview__group");
			const parentTop = parent.getBoundingClientRect().top;
			const parentBottom = parent.getBoundingClientRect().bottom;
			const parentLeft = parent.getBoundingClientRect().left;
			const parentRight = parent.getBoundingClientRect().right;
			const droppableBelowInParent = parent.contains(droppableBelow);
			parentalRestrictions = parentLeft < cloneLeft && parentRight > cloneRight && parentTop < cloneMiddelY && parentBottom > cloneMiddelY && droppableBelowInParent;
			const dragElementOldX = dragElement.getBoundingClientRect().left;
			if (dragElementOldX - cloneWidth / 2 - 8 >= cloneLeft || cloneLeft >= dragElementOldX + cloneWidth / 2 + 8) {
				if (parentalRestrictions) {
					document.querySelectorAll('.v3-kanbanview__group-col.v3-kanbanview__group-col--dragover')?.forEach(item => item?.classList.remove('v3-kanbanview__group-col--dragover'));
					droppableBelow?.classList.add('v3-kanbanview__group-col--dragover');
				}
			}
		}
		if (isCalendar) {
			const parentTop = parent.getBoundingClientRect().top;
			const parentBottom = parent.getBoundingClientRect().bottom;
			const parentLeft = parent.getBoundingClientRect().left;
			const parentRight = parent.getBoundingClientRect().right;
			parentalRestrictions = parentLeft < cloneLeft && parentRight > cloneRight && parentTop < cloneTop && parentBottom > cloneBottom;
			if (droppableBelow && parentalRestrictions) {
				document.querySelectorAll('.v3-calendar__day.v3-calendar__day--dragover')?.forEach(item => item?.classList.remove('v3-calendar__day--dragover'));
				droppableBelow?.closest('.v3-calendar__day').classList.add('v3-calendar__day--dragover');
				// droppableBelow.append(dragElement);
			}
		}
	};

	const onMouseUp = () => {
		finishDrag();
	};
	const startDrag = (event) => {
		if (isDragging) return;
		isDragging = true;

		if (isTouch) {
			timer = setTimeout(finishDrag, 600);
		}
		isCalendar = dragElement.classList.contains('v3-calendar__item');
		if (isCalendar) {
			parent = dragElement.closest('.v3-calendar');
			parent.classList.add('drag-element');
		}
		const clientX = isTouch ? event.touches[0].clientX : event.clientX;
		const clientY = isTouch ? event.touches[0].clientY : event.clientY;

		shiftX = clientX - dragElement.getBoundingClientRect().left;
		shiftY = clientY - dragElement.getBoundingClientRect().top;
		clone = dragElement.cloneNode(true);
		clone.classList.add('clone');
		clone.style.width = dragElement.getBoundingClientRect().width + "px";
		clone.style.height = dragElement.getBoundingClientRect().height + "px";
		dragElement.style.visibility = 'hidden';
		clone.style.position = 'fixed';
		clone.style.zIndex = 1000;
		document.body.append(clone);
		moveAt(clientX, clientY);
		document.addEventListener(eventMove, onMouseMove);
		document.addEventListener(eventEnd, onMouseUp);
	};
	const finishDrag = () => {
		if (!isDragging) return;
		isDragging = false;
		const columnBg = document.querySelectorAll('.show-bg');
		clone.remove();
		if (droppableBelow && parentalRestrictions) droppableBelow.append(dragElement);
		dragElement.style.visibility = '';
		if (columnBg.length) {
			columnBg.forEach(el => { el.classList.remove('show-bg'); });
		}
		droppableBelow = '';
		if (isCalendar) {
			checkEmptyDays(parent);
			parent.classList.remove('drag-element');
		}
		document.removeEventListener(eventMove, onMouseMove);
		document.removeEventListener(eventEnd, onMouseUp);
		updateRecord(dragElement);
		dragElement = null;
	};

	const updateRecord = async (dragElement) => {

		const reload = (anchor) => {
			var url = location.href;
			var hash = url.indexOf("#");
			if (hash >= 0)
				url = url.substring(0, hash);
			if (anchor)
				url += "#" + anchor;
			location.href = url;
			location.reload();
		};


		const dragTable = dragElement.closest("table");
		const vid = dragTable.dataset["viewid"];
		const fid = dragTable.dataset["fid"];
		var id = dragElement.dataset["rowid"];
		// let dragTarget = dragElement.closest(".td-calendar.td-draggable,.td-kanbanviewstatus.td-droppable");
		const dragTarget = dragElement.closest(".js-droppable[data-basevalue]");
		var to = dragTarget.dataset["basevalue"];
		var data = new FormData();
		data.append(`f_${fid}`, to);
		try {
			const response = await fetch(
				`js.aspx?cmd=rowsave&v=${encodeURIComponent(vid)}&id=${encodeURIComponent(id)}`, {
				method: "POST",
				// headers: [
				//	["Content-Type", "application/x-www-form-urlencoded"]
				// ],
				body: data
			});
			if (response.ok) {
				const data = await response.json();
				if (data.controldata && data.controldata.invalid) {
					var i = data.controldata.invalid, err = [];
					if (i.common) Array.prototype.push.apply(err, i.common);
					for (var k in i) {
						if (k != "common")
							err.push(i[k]);
					}
					// console.log("Kanban item #" + id + " was not changed: ", err);
					alert("There are errors:\r\n\r\n* " + err.join("\r\n* "));
				} else {
					// console.log("Kanban item #" + id + " status changed to", to);
				}
			} else {
				throw new Error(response.statusText);
			}
		} catch (e) {
			const msg = e.message;
			alert(msg);
			console.error("Kanban item #" + id + " status change error:", msg);
		}
		reload(dragElement.id);
	};

	const checkClick = () => {
		isClick = true;
	};

	let clickCount = 0;

	document.addEventListener(eventDown, event => {
		dragElement = event.target.closest('.js-draglist .js-draggable');
		if (!dragElement) return;

		if (event.button === 2) return;

		clickCount++;
		document.addEventListener(eventEnd, checkClick);

		document.ondragstart = function () {
			return false;
		};
		setTimeout(() => {
			if (isClick) {
				isClick = false;
				return;
			} else {
				if (clickCount < 2) {
					startDrag(event);
					clickCount = 0;
				}
			}
			document.removeEventListener(eventEnd, checkClick);
			clickCount = clickCount > 2 ? 0 : clickCount;
		}, 150);
	});
};
/*
ready(dragDrop);
*/